module.exports = __webpack_public_path__ + "img/denmark-cerebrovascular-disease-female.3f372f2c.png";